import { prepareLocationsList } from './widgetHelpers';
import cloneDeep from 'lodash-es/cloneDeep';
import isEqual from 'lodash-es/isEqual';
import map from 'lodash-es/map';
import orderBy from 'lodash-es/orderBy';
import sortBy from 'lodash-es/sortBy';

/**
 * Returns CSS class name on category ID for chart drawing
 * @param categoryId
 * @returns {string}
 */
export function getClassNameByCategoryId(categoryId) {
    switch (categoryId) {
        case 1:
            return 'ct-normal-bar';
        case 2:
            return 'ct-assistance-bar';
        case 3:
            return 'ct-emergency-bar';
        case 10:
            return 'ct-medical-high-bar';
        case 4:
            return 'ct-medical-medium-bar';
        case 9:
            return 'ct-medical-low-bar';
        case 5:
            return 'ct-error-bar';
        case 6:
            return 'ct-presence-bar';
        case 7:
            return 'ct-technical-bar';
        case 8:
            return 'ct-security-bar';
        case 11:
            return 'ct-service-bar';
        default:
            return '';
    }
}

/**
 * Checks if "areas" contains all possible areas from "allAreas"
 *
 * @param {{name: string, locations: {name: string}[]}[]} allAssignmentAreas
 * @param {string[]} areas
 * @returns {Boolean}
 */
export function allAreasInConfig(allAssignmentAreas, areas) {
    if (!areas || !allAssignmentAreas) {
        return false;
    }

    let ownAreas = orderBy([...areas]);
    let allAreas = orderBy(map(allAssignmentAreas, 'name'));

    return isEqual(ownAreas, allAreas);
}

/**
 * Checks if locations list contains all possible locations from given assignment areas
 *
 * @param {{name: string, locations: {name: string}[]}[]} allAssignmentAreas
 * @param {string[]} locations
 * @param {string[]} areas
 * @returns {boolean}
 */
export function allLocationsInConfig(allAssignmentAreas, locations, areas) {
    let allLocations = orderBy(prepareLocationsList([], areas, allAssignmentAreas));
    let ownLocations = orderBy([...locations]);

    return isEqual(allLocations, ownLocations);
}

/**
 * Clones and modifies widget configuration to be used in widget configurator.
 * Replaces full list of assignment areas and locations by empty arrays.
 * @param {{name: string, locations: {name: string}[]}[]} allAssignmentAreas
 * @param {{ id: number }[]} allCallTypes
 * @param {Object} configuration
 * @returns {Object}
 */
export function transformWidgetConfiguration(allAssignmentAreas, allCallTypes, configuration) {
    let result = cloneDeep(configuration);
    if (!!configuration.aa && allAreasInConfig(allAssignmentAreas, configuration.aa)) {
        result.aa = [];
    }

    if (
        configuration.locations &&
        allLocationsInConfig(allAssignmentAreas, configuration.locations, configuration.aa)
    ) {
        result.locations = [];
    }

    if (Array.isArray(configuration.call_types)) {
        result.call_types = isEqual(sortBy(configuration.call_types), sortBy(map(allCallTypes, 'id')))
            ? []
            : configuration.call_types;
    }

    return result;
}
